import { useEffect, useState } from 'react';
import { getSignedUpArrangements, Arrangement } from 'application/repositories/arrangementsRepository';
import { getCMSHostname } from 'helpers/getCMSHostname';
import { ArrangementsBanner } from 'ui/components';
import logger from 'helpers/logger';
import { useImpersonateId } from 'application/hooks/useImpersonateId';

export const ArrangementsBannerSignedUpFeature: React.FC<Umbraco.ArrangementsBannerSignedUp> = ({ content }) => {
	const [arrangements, setArrangements] = useState<Arrangement[]>([]);
	const [hasLoaded, setHasLoaded] = useState<boolean>(false);
	const [hasError, setHasError] = useState<boolean>(false);
	const impersonateId = useImpersonateId();

	useEffect(() => {
		getSignedUpArrangements(getCMSHostname(), impersonateId)
			.then((arrangements) => {
				if (arrangements?.length > 0) {
					setArrangements(arrangements);
				}
				setHasLoaded(true);
			})
			.catch((error) => {
				logger.error(error);
				setHasLoaded(true);
				setHasError(true);
			});
	}, [impersonateId]);

	return (
		<ArrangementsBanner
			hasError={hasError}
			hideComponent={hasLoaded && arrangements?.length < 1}
			arrangements={arrangements}
			{...content?.properties}
		/>
	);
};
